import { Workspace } from '@/features/iam/workspaces/Workspace'
import { collection } from '@/infra/collection'
import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'
import { MessageBankReply } from './MessageBankReply'

export type MessageBankProps = ModelProps<MessageBank>

/**
 * A workspace's canned replies.
 */
export class MessageBank extends Model<MessageBank> {
  id = Id.none

  @observable accessor workspace = Workspace.none
  @observable accessor dateCreated = unixEpoch()
  @observable accessor dateModified = unixEpoch()

  readonly replies = collection({
    getDataId: (d) => d.id,
    getModelId: (m) => m.id,
    create: () => new MessageBankReply(),
  })
}
